import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useCallback } from 'react';
import { X } from 'lucide-react';
import { eventBus } from '../events';
export const DownloadModal = ({ isOpen, url, downloadId, onClose }) => {
    const handleCancel = useCallback(() => {
        // Clear the download trigger from localStorage when user cancels
        if (downloadId) {
            eventBus.emit('download:consume', { downloadId });
        }
        onClose();
    }, [downloadId, onClose]);
    const handleConfirm = useCallback(() => {
        try {
            if (url) {
                window.open(url, '_blank');
            }
            if (downloadId) {
                eventBus.emit('download:consume', { downloadId });
            }
        }
        catch (_) { }
        onClose();
    }, [url, downloadId, onClose]);
    // Esc to close
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape' && isOpen)
                handleCancel();
        };
        if (isOpen)
            document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [isOpen, handleCancel]);
    if (!isOpen)
        return null;
    return (_jsxs("div", { className: "fixed inset-0 z-[70] flex items-center justify-center p-4", children: [_jsx("div", { className: "ls-modal-backdrop", onClick: handleCancel }), _jsxs("div", { className: "ls-modal-card ls-modal-card-animate relative w-full max-w-md flex flex-col", style: { maxHeight: '92vh' }, children: [_jsxs("div", { className: "flex items-center justify-between p-6 ls-modal-band-top shrink-0", style: { backgroundColor: 'var(--forest)' }, children: [_jsx("h2", { className: "text-xl font-semibold", style: { color: 'var(--sand)' }, children: "Download Ready" }), _jsx("button", { onClick: handleCancel, className: "p-1 rounded hover:bg-opacity-20 hover:bg-white transition-colors", style: { color: 'var(--sand)' }, children: _jsx(X, { size: 24 }) })] }), _jsx("div", { className: "p-6 overflow-y-auto min-h-0 flex-1", style: { backgroundColor: 'var(--sand)' }, children: _jsx("p", { className: "text-sm", style: { color: 'var(--charcoal)' }, children: "Your download is ready." }) }), _jsxs("div", { className: "flex items-center justify-end gap-3 p-6 ls-modal-band-bottom shrink-0", style: { backgroundColor: 'var(--pewter)' }, children: [_jsx("button", { onClick: handleCancel, className: "px-4 py-2 text-sm rounded-lg border transition-colors hover:bg-opacity-10 hover:bg-gray-500", style: {
                                    borderColor: 'var(--sand)',
                                    backgroundColor: 'transparent',
                                    color: 'var(--sand)'
                                }, children: "Cancel" }), _jsx("button", { onClick: handleConfirm, className: "px-4 py-2 text-sm rounded-lg transition-colors hover:bg-opacity-90", style: {
                                    backgroundColor: 'var(--forest)',
                                    color: 'var(--sand)'
                                }, title: "Start download", children: "Download" })] })] })] }));
};
